<template>
  <HermesBanner v-if="isHermesFlag" />
  <ChanelBanner v-else-if="isChanelFlag" />
</template>
<script setup>
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import ChanelBanner from '~/components/brandBanner/ChanelBanner.common';
import HermesBanner from '~/components/brandBanner/HermesBanner.common';

const { isHermesFlag, isChanelFlag } = useProductFlags();
</script>
